document.addEventListener("DOMContentLoaded", function () {

    const productDesc = document.querySelector('.product-desc');
    const heritageSet = document.querySelector('.heritage-set');

    // Parallax

    // productDesc
    if(productDesc) {
        const productGinseng = new setParallax('.product-desc__ginseng', '.product-desc__ginseng-img');
        const productrefill = new setParallax('.product-desc__refill-left', '.product-desc__refill-img');
        const productbanner = new setParallax('.product-desc__banner', '.product-desc__banner-img');
    }

    // heritageSet
    if(heritageSet) {
    }


});